import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { SustainabilityMetrics } from '@/models/sustainability';
import { getStartOfYear } from '@/helpers';
import { ui } from '@/constants';

const currentYear = new Date().getFullYear();

@Component({
  name: 'CmgSustainabilityStatsPage',
})
export default class CmgSustainabilityStatsPage extends Vue {
  isLoading = false;
  didError = false;

  async mounted() {
    if (!this.sustainabilityHistoryMetrics) {
      this.fetchOrderHistory();
    }
  }

  get isLoggedIn(): boolean | undefined {
    return this.$services.customer.isLoggedIn();
  }

  get foodprintDoodles(): string {
    return this.isMobile
      ? this.$appStore.state.cms.images.backgrounds.foodprintDoodlesAccountMobile.default
      : this.$appStore.state.cms.images.backgrounds.foodprintDoodlesAccountDestkop.default;
  }

  get sustainabilityHistoryMetrics(): SustainabilityMetrics | null {
    const history = this.$appStore.state.customer.sustainabilityMetrics.history;
    return history ? (history.numOfOrders ? history : null) : null;
  }

  get currentYear(): number {
    return currentYear;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth < ui.breakpoints.tablet;
  }

  onSignInButtonClick() {
    this.$services.ui.setModalVisibility('signIn', true);
  }

  async fetchOrderHistory() {
    this.isLoading = true;
    this.didError = false;

    try {
      await this.$services.sustainability.getHistorySustainabilityMetrics();
    } catch (_) {
      this.didError = true;
    } finally {
      this.isLoading = false;
    }
  }
}
